exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".descriptionContainer {\n  text-align: center;\n  margin: 4.167rem 2rem;\n  padding: 3rem 0;\n}\n\n.descText {\n  font-size: 1.867rem;\n}\n\n.tempText {\n  text-align: center;\n  margin: 2.083rem 0 0.5rem;\n  font-size: 1.4rem;\n}\n\n.tempText > a {\n  color: black;\n  text-decoration: none;\n  font-weight: bold;\n}\n", ""]);

// exports
